import React, { useEffect } from "react";
import { useParams } from "react-router";
import { Typography, CircularProgress } from "@material-ui/core";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { Wrapper } from "components/wrapper";
import { CustomPageProvider, useCustomPageState } from "./context/custom-page-context";
import { useCustomPageController } from "./context/custom-page-controller";
import { CustomPageContainer } from "./custom-page.styles";
import { SectionFactory } from "./custom-page-factory";

const CustomPageContent: React.FC = () => {
    const { customPage, loading, error } = useCustomPageState();
    const { loadCustomPage, clearCustomPage } = useCustomPageController();
    const { slug } = useParams<{ slug: string }>();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });

        if (slug) {
            loadCustomPage(slug);
        }

        return () => {
            clearCustomPage();
        };
    }, [slug]);

    if (loading) {
        return (
            <Wrapper>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                    <CircularProgress />
                </div>
            </Wrapper>
        );
    }

    if (error) {
        return (
            <>
                <Breadcrumb
                    items={[
                        { label: "Home", href: "/" },
                        { label: "Página não encontrada" },
                    ]}
                />
                <PageTitle>ERRO</PageTitle>
                <Wrapper>
                    <Typography color="error" variant="h6">
                        {error}
                    </Typography>
                </Wrapper>
            </>
        );
    }

    if (!customPage) {
        return (
            <>
                <Breadcrumb
                    items={[
                        { label: "Home", href: "/" },
                        { label: "Página não encontrada" },
                    ]}
                />
                <PageTitle>PÁGINA NÃO ENCONTRADA</PageTitle>
                <Wrapper>
                    <Typography variant="h6">
                        A página solicitada não foi encontrada.
                    </Typography>
                </Wrapper>
            </>
        );
    }

    return (
        <>
            <Breadcrumb
                items={[
                    { label: "Home", href: "/" },
                    { label: customPage.title },
                ]}
            />
            <PageTitle>{customPage.title.toUpperCase()}</PageTitle>
            <Wrapper>
                <CustomPageContainer>
                    {customPage.sections?.sort((a, b) => a.order - b.order).map((section) => (
                        <SectionFactory key={section.id} section={section} />
                    ))}
                </CustomPageContainer>
            </Wrapper>
        </>
    );
};

export function CustomPage() {
    return (
        <CustomPageProvider>
            <CustomPageContent />
        </CustomPageProvider>
    );
}
